<template>
  <div id="aboutPage" class="pageWrapper">
    <div
      class="pageHeader"
      :style="{
        backgroundImage: 'url(' + require('@/assets/bg/top-bg-home.jpg') + ')',
      }"
    >
      <div class="container" v-if="this.$store.state.user.user">
        <router-link :to="`/topics/${this.$store.state.user.user.id}`">
          <img
            class="pageHeaderLogo"
            src="@/assets/logo/next-era-white.png"
            alt="VIR Logo"
          />
        </router-link>
      </div>
    </div>
    <div class="pageContent">
      <div class="container">
        <div class="pageContentLeft">
          <div class="title">
            Welcome to the VIR Story Capture Platform
          </div>
          <div class="description">
            In anticipation of our centennial coming up in 2025, we’ve launched
            the VIR Story Capture Platform to record memories,
            anecdotes and important events from the last 20+ years for the
            company’s archives. Through this platform you can:
          </div>
          <div class="actionList">
            <div class="actionListRow">
              <img src="@/assets/icon/icon-1.png" alt="Tell Us" />
              <div>Tell us a story aloud and record it</div>
            </div>
            <div class="actionListRow">
              <img src="@/assets/icon/icon-2.png" alt="Write a story" />
              <div>Write a story down and submit it</div>
            </div>
            <div class="actionListRow">
              <img src="@/assets/icon/icon-3.png" alt="Upload and contribute" />
              <div>
                Upload and contribute digital files related to a story or topic
                — photographs, written documents, brochures, anything you think
                would help the archives capture the story including snapshots of
                physical items you think might belong in the archives
              </div>
            </div>
          </div>
        </div>
        <div class="pageContentRight" v-if="user">
          <div class="profileForm">
            <div class="profileFormHeader">
              Please start by telling us a little about yourself
            </div>
            <div class="profileFormBody">
              <div class="profileFormRow">
                <label for="firstName">First Name*</label>
                <input type="text" name="firstName" v-model="user.firstName"/>
              </div>
              <div class="profileFormRow">
                <label for="lastName">Last Name*</label>
                <input type="text" name="lastName" v-model="user.lastName"/>
              </div>
              <div class="profileFormRow">
                <label for="email">Email Address*</label>
                <input type="text" name="email" v-model="user.email"/>
              </div>
              <div class="profileFormRow">
                <label for="phoneNumber">Phone Number*</label>
                <input type="text" name="phoneNumber" v-model="user.phoneNumber" @input="acceptNumber"/>
              </div>
              <div class="profileFormRow">
                <label for="roleAtCompany">Role at VIR*</label>
                <select id="roleAtCompany" v-model="user.role">
                  <option>Current Employee</option>
                  <option>Retired or Former Employee</option>
                  <option>Other (including vendors, partners, etc.)</option>
                </select>
              </div>
              <div class="profileFormRow">
                <label for="department">Department or Area of Expertise</label>
                <input type="text" name="department" v-model="user.department"/>
              </div>
              <div class="profileFormRow timeline">
                <div class="timelineTitle">
                  Years active with VIR<br />(or predecessor
                  companies)
                </div>
                <div class="timelineInput">
                  <div class="year">
                    <label for="from">From:</label>
                    <select v-model="user.yearsActiveFrom">
                      <option v-for="i in yearsSinceFounded" :value="i + founded - 1" :key="i">{{i + founded - 1}}</option>
                    </select>
                  </div>
                  <div class="yearMid">until</div>
                  <div class="year">
                    <label for="to">To:</label>
                    <select v-model="user.yearsActiveTo">
                      <option value="present">Present</option>
                      <option v-for="i in yearsSinceFounded" :value="i + founded - 1" :key="i">{{i + founded - 1}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <p>* Required fields</p>
            </div>
            <div class="profileFormFooter">
              <div class="submission">
                <button @click="onClickSubmitProfile($event)" :class="{'loading': this.submitProfileLoading}">
                  <template v-if="!submitProfileLoading">Submit & Enter</template>
                  <template v-else><font-awesome-icon icon="cog" class="fa-spin" /></template>
                </button>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
    <TermsAndCondition v-if="termsAndConditionPopup" @changePasswordStatus="changePasswordStatus"/>
    <ChangePasswordPopup v-if="changePasswordPopup" @changePasswordStatus="changePasswordStatus"/>
  </div>
</template>

<script>
import axios from 'axios';
import {mapGetters} from 'vuex';
import TermsAndCondition from "@/components/sections/AboutPage/TermsAndCondition";
import ChangePasswordPopup from "@/components/sections/AboutPage/ChangePasswordPopup";

export default {
  components: {
    TermsAndCondition,
    ChangePasswordPopup
  },
  data(){
    return{
      founded:1965,      
      yearsSinceFounded:0,
      submitProfileLoading: false,
      termsAndConditionPopup: false,
      changePasswordPopup: false,
    }
  },  
  methods: {
    acceptNumber() {      

      let x = this.user.phoneNumber
      .replace(/\D/g, "")
      .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

      //this.user.phoneNumber = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
      this.user.phoneNumber = !x[2] ? x[1] : '' + x[1] + '' + x[2] + (x[3] ? '' + x[3] : '');
    },
    async onClickSubmitProfile(event){
      this.submitProfileLoading = true;
      if(!this.user.firstName || !this.user.lastName || !this.user.email || !this.user.phoneNumber || !this.user.role){
        this.submitProfileLoading = false;
        this.$swal("Error!", "Please complete all required fields", "error");
        return;
      }

      if(!this.user.agreedTerm){
        this.termsAndConditionPopup = true
      }else{
        const response = await axios.post(`user/updateUser/${this.user.id}`, this.user);
        if(response.data.success === true){
          this.$router.push(`/topics/${this.user.id}`);
        }else{
          this.submitProfileLoading = false;
          this.$swal("Error!", "Sorry, there is something wrong. Please contact your agent", "error");
        }
      }

     this.submitProfileLoading = false;
    },
    async changePasswordStatus(status){
      if(status === true){
        this.termsAndConditionPopup = false;
        this.changePasswordPopup = true;
      }
      
      if(status === false){
        this.termsAndConditionPopup = false;
        this.changePasswordPopup = false;
      }

      if(status === 'complete'){
        this.termsAndConditionPopup = false;
        this.changePasswordPopup = false;

        const response = await axios.post(`user/updateUser/${this.user.id}`, this.user);
        if(response.data.success === true){
          this.$router.push(`/topics/${this.user.id}`);
        }else{
          this.submitProfileLoading = false;
          this.$swal("Error!", "Sorry, there is something wrong. Please contact your agent", "error");
        }
      }
    }
  },
  mounted() {
    this.yearsSinceFounded = new Date().getFullYear() + 1 - this.founded;
  },
  updated() {
    this.yearsSinceFounded = new Date().getFullYear() + 1 - this.founded;
  },
  computed: {
    ...mapGetters(['user'])
  }
};
</script>

<style lang="scss" scoped>
p {
  font-family: Effra-Medium;
  font-size: 13px;
  color: #000000;
  letter-spacing: 0;
  margin-left: 15px;
}
.pageContent {
  margin-top: 38px;
  padding-bottom: 130px;
  .container{
    display: flex;

    @media (max-width: $lg) {
      flex-direction: column;
    }
  }
  .pageContentLeft {
    padding-right: 30px;
    .title {
      font-family: Effra-Light;
      font-size: 56px;
      color: #009ad6;
      letter-spacing: 0;
      line-height: 54px;
      margin-bottom: 25px;
      max-width: 447px;
    }
    .description {
      font-family: Effra-Regular;
      font-size: 16px;
      color: #5f5f5f;
      letter-spacing: 0;
      line-height: 21px;
      margin-bottom: 25px;
      margin-top: 25px;
    }
    .actionList {
      .actionListRow {
        font-family: Effra-Regular;
        font-size: 16px;
        color: #5f5f5f;
        letter-spacing: 0;
        line-height: 21px;
        display: flex;
        align-items: center;
        margin-bottom: 38px;
        &:last-child {
          margin-bottom: 0px;
        }

        img {
          max-width: 44px;
          margin-right: 30px;
        }
      }
    }
  }
  .pageContentRight {
    min-width: 400px;
    margin-top: -115px;

    @media (max-width: $lg) {
      margin-top: 30px;
      min-width: 100%;
    }
    .profileForm {
      max-width: 400px;
      background-image: linear-gradient(180deg, #f6f6f6 0%, #ffffff 100%);
      box-shadow: 0 4px 67px 0 rgba(0, 0, 0, 0.13);
      border-radius: 8px;
      position: relative;

      @media (max-width: $lg) {
        max-width: none;
      }
      .profileFormHeader {
        background: #3d3d3d;
        font-family: Effra-Medium;
        font-size: 13px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        line-height: 23px;
        text-transform: uppercase;
        padding: 27px 20px;
        border-top-right-radius: 8px;
        border-top-left-radius: 8px;
      }
      .profileFormBody {
        padding: 10px 30px;
        padding-top: 20px;
        .profileFormRow {
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-bottom: 24px;
          &:last-child{
            margin-bottom: 0px;
          }
          select {
            background: #e4e4e4;
            font-family: 'Effra-Regular';
            font-size: 16px;
            color: #000000;
            letter-spacing: 0;
            height: 36px;
            border: 0px;
            padding: 0 10px;
            cursor: pointer;
            //appearance: none;
            border-radius: 5px;
            option {
              font-family: 'Effra-Regular';
            }
          }
          label {
            font-family: Effra-Medium;
            font-size: 13px;
            color: #000000;
            letter-spacing: 0;
            margin-left: 15px;
          }
          input {
            background: #eaeaea;
            border-radius: 5px;
            font-family: Effra-Regular;
            font-size: 16px;
            color: #000000;
            letter-spacing: 0;
            border: 0px;
            padding: 5px 15px;
          }
          &.timeline {
            .timelineTitle {
              margin-bottom: 15px;
              margin-left: 15px;
              font-family: Effra-Medium;
              font-size: 13px;
              color: #000000;
              letter-spacing: 0;
              line-height: 15px;
            }
            .timelineInput {
              display: flex;
              align-items: center;
              justify-content: space-between;
              .year {
                display: flex;
                align-items: center;
                padding: 3px 20px;
                background: #eaeaea;
                border-radius: 5px;
                input {
                  width: 65px;
                  padding: 5px;
                  font-family: Effra-Regular;
                  font-size: 16px;
                  color: #000000;
                  letter-spacing: 0;
                  line-height: 19px;
                }
                label {
                  margin: 0;
                }
              }
              .yearMid {
                font-family: Effra-Regular;
                font-size: 16px;
                color: #000000;
                letter-spacing: 0;
                text-align: center;
              }
            }
          }
          &.checkbox {
            .checkboxCol {
              display: flex;
              align-items: center;
              input {
                height: auto;
              }
              margin-left: 30px;
              &:first-child {
                margin-left: 0px;
              }
              span {
                font-family: Effra-Medium;
                font-size: 13px;
                color: #000000;
                letter-spacing: 0;
                margin-left: 13px;
              }
            }
            .checkboxCol {
              display: inline-flex;
              cursor: pointer;
              position: relative;
              & > span {
                //color: #3d3d3d;
                padding: 0.5rem 0.25rem;
              }
              & > input {
                height: 25px;
                width: 25px;
                appearance: none;
                border: 1px solid #3d3d3d;
                border-radius: 4px;
                outline: none;
                transition-duration: 0.3s;
                background-color: #ffffff;
                cursor: pointer;
              }
              & > input:checked {
                border: 1px solid #ffffff;
                background-color: #3d3d3d;
              }

              & > input:checked + span::before {
                content: "\2713";
                display: block;
                text-align: center;
                color: #ffffff;
                position: absolute;
                left: 9px;
                top: 9px;
                pointer-events: none;
              }

              & > input:active {
                border: 2px solid #3d3d3d;
              }
            }
          }
        }
      }
      .profileFormFooter {
        .tc {
          background: #3d3d3d;
          font-family: Effra-Regular;
          font-size: 11px;
          color: #ffffff;
          letter-spacing: 0;
          line-height: 15px;
          position: relative;
          padding: 5px 30px;
          max-height: 150px;
          overflow-y: auto;
          //&:after {
          //  content: "";
          //  left: 0;
          //  top: 0;
          //  width: 100%;
          //  height: 100%;
          //  background-image: linear-gradient(
          //    180deg,
          //    rgba(61, 61, 61, 0) 0%,
          //    #3d3d3d 100%
          //  );
          //  position: absolute;
          //}
        }
        .submission {
          text-align: center;
          padding: 20px 30px;
          button {
            background: #009ad6;
            border-radius: 5px;
            font-family: Effra-Heavy;
            font-size: 16px;
            color: #ffffff;
            letter-spacing: 0;
            text-align: center;
            text-transform: uppercase;
            border: 0px;
            padding: 2px 30px;

            &.loading{
              pointer-events: none;
            }
          }
        }
      }
    }
  }
}
</style>